// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"56444cd7","360":"7abb2084","377":"0045b37c","509":"c58ec2c9"}[chunkId] + ".chunk.css";
};